// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"55cc0d0d","433":"722df5f2","455":"7dec364e","488":"a3b75791","728":"3ba6dda8","774":"20e93047","857":"c1ce5289","947":"9deaa816","990":"1c7ec55e"}[chunkId] + ".chunk.js";
};